/* eslint-disable indent */
import { request } from '../request';

const shopping = {
  // 商品详情页获取优惠
  get_product_coupon(data) {
    return request('/api/products/get_product_coupon', 'get', {
      ...data,
      utm_info: window
        ? {
            pub_zl_utm_source:
              window.latestChannelAttribute.expires > Date.now()
                ? window.latestChannelAttribute.pub_zl_utm_source || undefined
                : undefined,
            pub_zl_utm_medium:
              window.latestChannelAttribute.expires > Date.now()
                ? window.latestChannelAttribute.pub_zl_utm_medium || undefined
                : undefined,
            pub_zl_utm_campaign:
              window.latestChannelAttribute.expires > Date.now()
                ? window.latestChannelAttribute.pub_zl_utm_campaign || undefined
                : undefined,
            pub_zl_referrer:
              window.latestChannelAttribute.expires > Date.now()
                ? window.latestChannelAttribute.pub_zl_referrer || undefined
                : undefined,
          }
        : {},
    });
  },
  // 网红信息
  celebrity(data) {
    return request('/api/public/celebrity', 'post', data);
  },
  // 批发
  wholesale(data) {
    return request('/api/public/wholesale', 'post', data);
  },
  // 网红博客
  redWebBlog(data) {
    return request('/api/public/influencer', 'post', data);
  },
};

export default shopping;
